// Top US cities by population (~500 most populous), formatted as
// "City, ST". Used by the Market Report landing page to power the
// city autocomplete in the hero form. Sorted roughly by population
// so prefix matches surface the largest matching markets first.
//
// This list intentionally avoids any external API dependency so
// suggestions are instant and zero-cost. Customers in smaller cities
// can still type any value — the input is free-text and falls back
// to whatever they enter.

const US_CITIES = [
  "New York, NY",
  "Los Angeles, CA",
  "Chicago, IL",
  "Houston, TX",
  "Phoenix, AZ",
  "Philadelphia, PA",
  "San Antonio, TX",
  "San Diego, CA",
  "Dallas, TX",
  "Austin, TX",
  "Jacksonville, FL",
  "San Jose, CA",
  "Fort Worth, TX",
  "Columbus, OH",
  "Charlotte, NC",
  "Indianapolis, IN",
  "San Francisco, CA",
  "Seattle, WA",
  "Denver, CO",
  "Washington, DC",
  "Nashville, TN",
  "Oklahoma City, OK",
  "El Paso, TX",
  "Boston, MA",
  "Portland, OR",
  "Las Vegas, NV",
  "Detroit, MI",
  "Memphis, TN",
  "Louisville, KY",
  "Baltimore, MD",
  "Milwaukee, WI",
  "Albuquerque, NM",
  "Tucson, AZ",
  "Fresno, CA",
  "Mesa, AZ",
  "Sacramento, CA",
  "Atlanta, GA",
  "Kansas City, MO",
  "Colorado Springs, CO",
  "Omaha, NE",
  "Raleigh, NC",
  "Miami, FL",
  "Long Beach, CA",
  "Virginia Beach, VA",
  "Oakland, CA",
  "Minneapolis, MN",
  "Tulsa, OK",
  "Bakersfield, CA",
  "Tampa, FL",
  "Arlington, TX",
  "Wichita, KS",
  "Aurora, CO",
  "New Orleans, LA",
  "Cleveland, OH",
  "Anaheim, CA",
  "Henderson, NV",
  "Honolulu, HI",
  "Riverside, CA",
  "Santa Ana, CA",
  "Corpus Christi, TX",
  "Lexington, KY",
  "Stockton, CA",
  "Saint Paul, MN",
  "Cincinnati, OH",
  "St. Louis, MO",
  "Pittsburgh, PA",
  "Greensboro, NC",
  "Lincoln, NE",
  "Anchorage, AK",
  "Plano, TX",
  "Orlando, FL",
  "Irvine, CA",
  "Newark, NJ",
  "Toledo, OH",
  "Durham, NC",
  "Chula Vista, CA",
  "Fort Wayne, IN",
  "Jersey City, NJ",
  "St. Petersburg, FL",
  "Laredo, TX",
  "Madison, WI",
  "Chandler, AZ",
  "Buffalo, NY",
  "Lubbock, TX",
  "Scottsdale, AZ",
  "Reno, NV",
  "Glendale, AZ",
  "Gilbert, AZ",
  "Winston-Salem, NC",
  "North Las Vegas, NV",
  "Norfolk, VA",
  "Chesapeake, VA",
  "Garland, TX",
  "Irving, TX",
  "Hialeah, FL",
  "Fremont, CA",
  "Boise, ID",
  "Richmond, VA",
  "Baton Rouge, LA",
  "Spokane, WA",
  "Des Moines, IA",
  "Tacoma, WA",
  "San Bernardino, CA",
  "Modesto, CA",
  "Fontana, CA",
  "Santa Clarita, CA",
  "Birmingham, AL",
  "Oxnard, CA",
  "Fayetteville, NC",
  "Moreno Valley, CA",
  "Rochester, NY",
  "Glendale, CA",
  "Huntington Beach, CA",
  "Salt Lake City, UT",
  "Grand Rapids, MI",
  "Amarillo, TX",
  "Yonkers, NY",
  "Aurora, IL",
  "Montgomery, AL",
  "Akron, OH",
  "Little Rock, AR",
  "Huntsville, AL",
  "Augusta, GA",
  "Port St. Lucie, FL",
  "Grand Prairie, TX",
  "Columbus, GA",
  "Tallahassee, FL",
  "Overland Park, KS",
  "Tempe, AZ",
  "McKinney, TX",
  "Mobile, AL",
  "Cape Coral, FL",
  "Shreveport, LA",
  "Frisco, TX",
  "Knoxville, TN",
  "Worcester, MA",
  "Brownsville, TX",
  "Vancouver, WA",
  "Fort Lauderdale, FL",
  "Sioux Falls, SD",
  "Ontario, CA",
  "Chattanooga, TN",
  "Providence, RI",
  "Newport News, VA",
  "Rancho Cucamonga, CA",
  "Santa Rosa, CA",
  "Peoria, AZ",
  "Oceanside, CA",
  "Elk Grove, CA",
  "Salem, OR",
  "Pembroke Pines, FL",
  "Eugene, OR",
  "Garden Grove, CA",
  "Cary, NC",
  "Fort Collins, CO",
  "Corona, CA",
  "Springfield, MO",
  "Jackson, MS",
  "Alexandria, VA",
  "Hayward, CA",
  "Clarksville, TN",
  "Lakewood, CO",
  "Lancaster, CA",
  "Salinas, CA",
  "Palmdale, CA",
  "Hollywood, FL",
  "Springfield, MA",
  "Macon, GA",
  "Kansas City, KS",
  "Sunnyvale, CA",
  "Pomona, CA",
  "Killeen, TX",
  "Escondido, CA",
  "Pasadena, TX",
  "Naperville, IL",
  "Bellevue, WA",
  "Joliet, IL",
  "Murfreesboro, TN",
  "Midland, TX",
  "Rockford, IL",
  "Paterson, NJ",
  "Savannah, GA",
  "Bridgeport, CT",
  "Torrance, CA",
  "McAllen, TX",
  "Syracuse, NY",
  "Surprise, AZ",
  "Denton, TX",
  "Roseville, CA",
  "Thornton, CO",
  "Miramar, FL",
  "Pasadena, CA",
  "Mesquite, TX",
  "Olathe, KS",
  "Dayton, OH",
  "Carrollton, TX",
  "Waco, TX",
  "Orange, CA",
  "Fullerton, CA",
  "Charleston, SC",
  "West Valley City, UT",
  "Visalia, CA",
  "Hampton, VA",
  "Gainesville, FL",
  "Warren, MI",
  "Coral Springs, FL",
  "Cedar Rapids, IA",
  "Round Rock, TX",
  "Sterling Heights, MI",
  "Kent, WA",
  "Columbia, SC",
  "Santa Clara, CA",
  "New Haven, CT",
  "Stamford, CT",
  "Concord, CA",
  "Elizabeth, NJ",
  "Athens, GA",
  "Thousand Oaks, CA",
  "Lafayette, LA",
  "Simi Valley, CA",
  "Topeka, KS",
  "Norman, OK",
  "Fargo, ND",
  "Wilmington, NC",
  "Abilene, TX",
  "Odessa, TX",
  "Columbia, MO",
  "Pearland, TX",
  "Victorville, CA",
  "Hartford, CT",
  "Vallejo, CA",
  "Allentown, PA",
  "Berkeley, CA",
  "Richardson, TX",
  "Arvada, CO",
  "Ann Arbor, MI",
  "Rochester, MN",
  "Cambridge, MA",
  "Sugar Land, TX",
  "Lansing, MI",
  "Evansville, IN",
  "College Station, TX",
  "Fairfield, CA",
  "Clearwater, FL",
  "Beaumont, TX",
  "Independence, MO",
  "Provo, UT",
  "West Jordan, UT",
  "Murrieta, CA",
  "Palm Bay, FL",
  "El Monte, CA",
  "Carlsbad, CA",
  "North Charleston, SC",
  "Temecula, CA",
  "Clovis, CA",
  "Springfield, IL",
  "Meridian, ID",
  "Westminster, CO",
  "Costa Mesa, CA",
  "High Point, NC",
  "Manchester, NH",
  "Pueblo, CO",
  "Lakeland, FL",
  "Pompano Beach, FL",
  "West Palm Beach, FL",
  "Antioch, CA",
  "Everett, WA",
  "Downey, CA",
  "Lowell, MA",
  "Centennial, CO",
  "Elgin, IL",
  "Richmond, CA",
  "Peoria, IL",
  "Broken Arrow, OK",
  "Miami Gardens, FL",
  "Billings, MT",
  "Jurupa Valley, CA",
  "Sandy Springs, GA",
  "Gresham, OR",
  "Lewisville, TX",
  "Hillsboro, OR",
  "Ventura, CA",
  "Greeley, CO",
  "Inglewood, CA",
  "Waterbury, CT",
  "League City, TX",
  "Santa Maria, CA",
  "Tyler, TX",
  "Davie, FL",
  "Lakewood, NJ",
  "Daly City, CA",
  "Boulder, CO",
  "Allen, TX",
  "West Covina, CA",
  "Sparks, NV",
  "Wichita Falls, TX",
  "Green Bay, WI",
  "San Mateo, CA",
  "Norwalk, CA",
  "Rialto, CA",
  "Las Cruces, NM",
  "Chico, CA",
  "El Cajon, CA",
  "Burbank, CA",
  "South Bend, IN",
  "Renton, WA",
  "Vista, CA",
  "Davenport, IA",
  "Edinburg, TX",
  "Tuscaloosa, AL",
  "Carmel, IN",
  "Spokane Valley, WA",
  "San Angelo, TX",
  "Vacaville, CA",
  "Clinton, MI",
  "Bend, OR",
  "Woodbridge, NJ",
  "Tracy, CA",
  "Tustin, CA",
  "Edmond, OK",
  "Greenville, NC",
  "Mountain View, CA",
  "Brockton, MA",
  "New Bedford, MA",
  "Quincy, MA",
  "Chino, CA",
  "Lynn, MA",
  "Springdale, AR",
  "Fishers, IN",
  "Bellingham, WA",
  "Champaign, IL",
  "San Marcos, CA",
  "Lake Forest, CA",
  "Fall River, MA",
  "Fayetteville, AR",
  "Newton, MA",
  "Alhambra, CA",
  "Macomb, MI",
  "Buckeye, AZ",
  "Bloomington, MN",
  "Lawrence, KS",
  "Hesperia, CA",
  "Greenville, SC",
  "Westminster, CA",
  "Hawthorne, CA",
  "Largo, FL",
  "Whittier, CA",
  "Federal Way, WA",
  "Boca Raton, FL",
  "Sioux City, IA",
  "Roanoke, VA",
  "Citrus Heights, CA",
  "Pawtucket, RI",
  "Mission, TX",
  "Bloomington, IN",
  "Albany, NY",
  "Avondale, AZ",
  "Indio, CA",
  "Lawton, OK",
  "Compton, CA",
  "Beaverton, OR",
  "Conroe, TX",
  "Goodyear, AZ",
  "Trenton, NJ",
  "Brick, NJ",
  "Hemet, CA",
  "Camden, NJ",
  "Menifee, CA",
  "Livonia, MI",
  "Sandy, UT",
  "Schaumburg, IL",
  "Plymouth, MN",
  "Bolingbrook, IL",
  "Bryan, TX",
  "Pharr, TX",
  "Pleasanton, CA",
  "Flower Mound, TX",
  "Concord, NC",
  "Auburn, WA",
  "Maple Grove, MN",
  "Yuma, AZ",
  "Lehi, UT",
  "Pflugerville, TX",
  "Layton, UT",
  "Brooklyn Park, MN",
  "Tracy, CA",
  "Dearborn, MI",
  "Rio Rancho, NM",
  "Norwalk, CT",
  "Kennewick, WA",
  "Folsom, CA",
  "Largo, MD",
  "Decatur, IL",
  "Napa, CA",
  "Orem, UT",
  "Gary, IN",
  "Lake Charles, LA",
  "Bayonne, NJ",
  "Tigard, OR",
  "Manteca, CA",
  "Mission Viejo, CA",
  "Edinburg, TX",
  "Rapid City, SD",
  "Hoover, AL",
  "Reading, PA",
  "Tuckahoe, NY",
  "St. Joseph, MO",
  "Fishers, IN",
  "Frederick, MD",
  "Gulfport, MS",
  "Tamarac, FL",
  "Apple Valley, CA",
  "Albany, GA",
  "St. George, UT",
  "Suffolk, VA",
  "Yakima, WA",
  "Pinellas Park, FL",
  "St. Charles, MO",
  "Arlington Heights, IL",
  "Beaumont, CA",
  "Bossier City, LA",
  "Smyrna, TN",
  "South San Francisco, CA",
  "Camarillo, CA",
  "North Richland Hills, TX",
  "Yuba City, CA",
  "Cheyenne, WY",
  "Duluth, MN",
  "Pittsburg, CA",
  "Asheville, NC",
  "Erie, PA",
  "Kalamazoo, MI",
  "Athens, OH",
  "Idaho Falls, ID",
  "Suffolk, VA",
  "St. Cloud, MN",
  "Rogers, AR",
  "Brentwood, CA",
  "Daytona Beach, FL",
  "Sarasota, FL",
  "Melbourne, FL",
  "Cape Girardeau, MO",
  "Sanford, FL",
  "Coon Rapids, MN",
  "Round Lake Beach, IL",
  "Rocklin, CA",
  "Yorba Linda, CA",
  "Asheboro, NC",
  "Kissimmee, FL",
  "Apopka, FL",
  "Doral, FL",
  "Casper, WY",
  "Plantation, FL",
  "Sunrise, FL",
  "Pearl City, HI",
  "Kailua, HI",
  "Cedar Park, TX",
  "Boynton Beach, FL",
  "Grapevine, TX",
  "Janesville, WI",
  "Hoboken, NJ",
  "Apex, NC",
  "Eagan, MN",
  "Mansfield, TX",
  "Coconut Creek, FL",
  "Bowling Green, KY",
  "St. Cloud, FL",
  "Coppell, TX",
  "Encinitas, CA",
  "Twin Falls, ID",
  "Wausau, WI",
  "Oshkosh, WI",
  "Eau Claire, WI",
  "Loveland, CO",
  "Bartlett, TN",
  "Castle Rock, CO",
  "Wylie, TX",
  "Schenectady, NY",
  "Apex, NC",
  "Mount Pleasant, SC",
  "Kennesaw, GA",
  "Roswell, GA",
  "Marietta, GA",
  "Johns Creek, GA",
  "Alpharetta, GA",
  "Smyrna, GA",
  "Sandy Springs, GA",
  "Brookhaven, GA",
  "Peachtree Corners, GA",
  "Decatur, GA",
  "Stockbridge, GA",
  "Auburn, AL",
  "Madison, AL",
  "Vestavia Hills, AL",
  "Florence, AL",
  "Dothan, AL",
  "Prescott, AZ",
  "Flagstaff, AZ",
  "Sierra Vista, AZ",
  "Maricopa, AZ",
  "Casa Grande, AZ",
  "Hot Springs, AR",
  "Conway, AR",
  "Jonesboro, AR",
  "Bentonville, AR",
  "Pine Bluff, AR",
  "El Centro, CA",
  "Eureka, CA",
  "Lompoc, CA",
  "Madera, CA",
  "Merced, CA",
  "Redding, CA",
  "Salinas, CA",
  "Santa Cruz, CA",
  "Truckee, CA",
  "Ukiah, CA",
  "Watsonville, CA",
  "Aspen, CO",
  "Durango, CO",
  "Glenwood Springs, CO",
  "Grand Junction, CO",
  "Pueblo, CO",
  "Steamboat Springs, CO",
  "Telluride, CO",
  "Vail, CO",
  "Danbury, CT",
  "Greenwich, CT",
  "Norwich, CT",
  "Stamford, CT",
  "Waterbury, CT",
  "West Hartford, CT",
  "Dover, DE",
  "Newark, DE",
  "Wilmington, DE",
  "Bonita Springs, FL",
  "Boca Raton, FL",
  "Bradenton, FL",
  "Coral Gables, FL",
  "Davie, FL",
  "Deerfield Beach, FL",
  "Delray Beach, FL",
  "Estero, FL",
  "Fort Myers, FL",
  "Gainesville, FL",
  "Homestead, FL",
  "Jupiter, FL",
  "Key West, FL",
  "Lakeland, FL",
  "Naples, FL",
  "Ocala, FL",
  "Palm Beach Gardens, FL",
  "Panama City, FL",
  "Pensacola, FL",
  "Port Orange, FL",
  "Sarasota, FL",
  "St. Augustine, FL",
  "Tarpon Springs, FL",
  "Venice, FL",
  "Vero Beach, FL",
  "Weston, FL",
  "Winter Park, FL",
  "Athens, GA",
  "Augusta, GA",
  "Columbus, GA",
  "Macon, GA",
  "Savannah, GA",
  "Valdosta, GA",
  "Warner Robins, GA",
  "Hilo, HI",
  "Kahului, HI",
  "Coeur d'Alene, ID",
  "Nampa, ID",
  "Pocatello, ID",
  "Champaign, IL",
  "Decatur, IL",
  "Evanston, IL",
  "Naperville, IL",
  "Oak Park, IL",
  "Schaumburg, IL",
  "Skokie, IL",
  "Tinley Park, IL",
  "Bloomington, IN",
  "Carmel, IN",
  "Fishers, IN",
  "Indianapolis, IN",
  "Lafayette, IN",
  "Muncie, IN",
  "South Bend, IN",
  "Terre Haute, IN",
  "West Lafayette, IN",
  "Ames, IA",
  "Council Bluffs, IA",
  "Davenport, IA",
  "Iowa City, IA",
  "West Des Moines, IA",
  "Lawrence, KS",
  "Manhattan, KS",
  "Olathe, KS",
  "Topeka, KS",
  "Bowling Green, KY",
  "Frankfort, KY",
  "Lexington, KY",
  "Owensboro, KY",
  "Lake Charles, LA",
  "Metairie, LA",
  "Slidell, LA",
  "Augusta, ME",
  "Bangor, ME",
  "Portland, ME",
  "Annapolis, MD",
  "Bethesda, MD",
  "Bowie, MD",
  "Columbia, MD",
  "Frederick, MD",
  "Gaithersburg, MD",
  "Germantown, MD",
  "Rockville, MD",
  "Silver Spring, MD",
  "Towson, MD",
  "Brookline, MA",
  "Framingham, MA",
  "Lawrence, MA",
  "Newton, MA",
  "Plymouth, MA",
  "Quincy, MA",
  "Somerville, MA",
  "Worcester, MA",
  "Battle Creek, MI",
  "Flint, MI",
  "Grand Rapids, MI",
  "Kalamazoo, MI",
  "Lansing, MI",
  "Muskegon, MI",
  "Pontiac, MI",
  "Saginaw, MI",
  "Sterling Heights, MI",
  "Traverse City, MI",
  "Troy, MI",
  "Warren, MI",
  "Bloomington, MN",
  "Brooklyn Park, MN",
  "Burnsville, MN",
  "Duluth, MN",
  "Eagan, MN",
  "Eden Prairie, MN",
  "Edina, MN",
  "Mankato, MN",
  "Maple Grove, MN",
  "Minnetonka, MN",
  "Plymouth, MN",
  "Rochester, MN",
  "Saint Cloud, MN",
  "Woodbury, MN",
  "Biloxi, MS",
  "Hattiesburg, MS",
  "Jackson, MS",
  "Meridian, MS",
  "Tupelo, MS",
  "Branson, MO",
  "Columbia, MO",
  "Joplin, MO",
  "Lee's Summit, MO",
  "O'Fallon, MO",
  "Springfield, MO",
  "St. Charles, MO",
  "Bozeman, MT",
  "Helena, MT",
  "Missoula, MT",
  "Bellevue, NE",
  "Grand Island, NE",
  "Carson City, NV",
  "Concord, NH",
  "Manchester, NH",
  "Nashua, NH",
  "Atlantic City, NJ",
  "Cherry Hill, NJ",
  "Edison, NJ",
  "Toms River, NJ",
  "Roswell, NM",
  "Santa Fe, NM",
  "Albany, NY",
  "Binghamton, NY",
  "Brooklyn, NY",
  "Hempstead, NY",
  "Huntington, NY",
  "Ithaca, NY",
  "Levittown, NY",
  "Long Island City, NY",
  "Mount Vernon, NY",
  "New Rochelle, NY",
  "Niagara Falls, NY",
  "Poughkeepsie, NY",
  "Queens, NY",
  "Saratoga Springs, NY",
  "Schenectady, NY",
  "Staten Island, NY",
  "Troy, NY",
  "Utica, NY",
  "White Plains, NY",
  "Yonkers, NY",
  "Apex, NC",
  "Asheville, NC",
  "Burlington, NC",
  "Cary, NC",
  "Chapel Hill, NC",
  "Charlotte, NC",
  "Concord, NC",
  "Durham, NC",
  "Fayetteville, NC",
  "Gastonia, NC",
  "Greensboro, NC",
  "Greenville, NC",
  "High Point, NC",
  "Huntersville, NC",
  "Raleigh, NC",
  "Wilmington, NC",
  "Winston-Salem, NC",
  "Bismarck, ND",
  "Fargo, ND",
  "Grand Forks, ND",
  "Akron, OH",
  "Canton, OH",
  "Cincinnati, OH",
  "Cleveland, OH",
  "Columbus, OH",
  "Dayton, OH",
  "Lakewood, OH",
  "Parma, OH",
  "Toledo, OH",
  "Youngstown, OH",
  "Broken Arrow, OK",
  "Edmond, OK",
  "Lawton, OK",
  "Norman, OK",
  "Oklahoma City, OK",
  "Tulsa, OK",
  "Beaverton, OR",
  "Bend, OR",
  "Eugene, OR",
  "Gresham, OR",
  "Hillsboro, OR",
  "Medford, OR",
  "Portland, OR",
  "Salem, OR",
  "Allentown, PA",
  "Bethlehem, PA",
  "Erie, PA",
  "Harrisburg, PA",
  "Lancaster, PA",
  "Philadelphia, PA",
  "Pittsburgh, PA",
  "Reading, PA",
  "Scranton, PA",
  "Wilkes-Barre, PA",
  "Cranston, RI",
  "Newport, RI",
  "Providence, RI",
  "Warwick, RI",
  "Charleston, SC",
  "Columbia, SC",
  "Greenville, SC",
  "Hilton Head Island, SC",
  "Mount Pleasant, SC",
  "Myrtle Beach, SC",
  "North Charleston, SC",
  "Rock Hill, SC",
  "Pierre, SD",
  "Rapid City, SD",
  "Sioux Falls, SD",
  "Chattanooga, TN",
  "Clarksville, TN",
  "Franklin, TN",
  "Knoxville, TN",
  "Memphis, TN",
  "Murfreesboro, TN",
  "Nashville, TN",
  "Abilene, TX",
  "Allen, TX",
  "Amarillo, TX",
  "Arlington, TX",
  "Austin, TX",
  "Beaumont, TX",
  "Brownsville, TX",
  "Carrollton, TX",
  "College Station, TX",
  "Conroe, TX",
  "Corpus Christi, TX",
  "Dallas, TX",
  "Denton, TX",
  "Edinburg, TX",
  "El Paso, TX",
  "Fort Worth, TX",
  "Frisco, TX",
  "Garland, TX",
  "Grand Prairie, TX",
  "Houston, TX",
  "Irving, TX",
  "Killeen, TX",
  "Laredo, TX",
  "League City, TX",
  "Lewisville, TX",
  "Lubbock, TX",
  "McAllen, TX",
  "McKinney, TX",
  "Mesquite, TX",
  "Midland, TX",
  "Odessa, TX",
  "Pasadena, TX",
  "Pearland, TX",
  "Plano, TX",
  "Richardson, TX",
  "Round Rock, TX",
  "San Angelo, TX",
  "San Antonio, TX",
  "Sugar Land, TX",
  "Tyler, TX",
  "Waco, TX",
  "Wichita Falls, TX",
  "Logan, UT",
  "Ogden, UT",
  "Orem, UT",
  "Provo, UT",
  "St. George, UT",
  "Salt Lake City, UT",
  "Sandy, UT",
  "West Jordan, UT",
  "West Valley City, UT",
  "Burlington, VT",
  "Montpelier, VT",
  "Alexandria, VA",
  "Arlington, VA",
  "Charlottesville, VA",
  "Chesapeake, VA",
  "Hampton, VA",
  "Lynchburg, VA",
  "Newport News, VA",
  "Norfolk, VA",
  "Portsmouth, VA",
  "Richmond, VA",
  "Roanoke, VA",
  "Suffolk, VA",
  "Virginia Beach, VA",
  "Bellevue, WA",
  "Bellingham, WA",
  "Everett, WA",
  "Kent, WA",
  "Olympia, WA",
  "Renton, WA",
  "Seattle, WA",
  "Spokane, WA",
  "Tacoma, WA",
  "Vancouver, WA",
  "Yakima, WA",
  "Charleston, WV",
  "Huntington, WV",
  "Morgantown, WV",
  "Wheeling, WV",
  "Appleton, WI",
  "Eau Claire, WI",
  "Green Bay, WI",
  "Kenosha, WI",
  "Madison, WI",
  "Milwaukee, WI",
  "Oshkosh, WI",
  "Racine, WI",
  "Waukesha, WI",
  "Casper, WY",
  "Cheyenne, WY",
  "Jackson, WY",
];

// De-duplicate while preserving original ordering. The seed list above
// includes some intentional repeats from the population-sorted prefix
// followed by alphabetical state-by-state sections; this keeps the most
// populous markets at the top of suggestion results.
const seen = new Set();
const dedupedCities = [];
for (const city of US_CITIES) {
  const key = city.toLowerCase();
  if (!seen.has(key)) {
    seen.add(key);
    dedupedCities.push(city);
  }
}

export const CITIES = dedupedCities;

// Returns up to `limit` cities matching the given query.
// Matches are case-insensitive and require the query to appear as a
// substring; matches at the very start of the city name are surfaced
// first to preserve a useful prefix-search feel.
export function searchCities(query, limit = 8) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return [];

  const startsWith = [];
  const contains = [];

  for (const city of CITIES) {
    const lower = city.toLowerCase();
    if (lower.startsWith(q)) {
      startsWith.push(city);
    } else if (lower.includes(q)) {
      contains.push(city);
    }
    if (startsWith.length >= limit) break;
  }

  return [...startsWith, ...contains].slice(0, limit);
}

export default CITIES;
